module.exports = __webpack_public_path__ + "static/media/washing-dishes.fadcd6dd.png";